import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsAutoSchedulerRoute: InvariantJiraRoute = {
	name: 'plan-settings-auto-scheduler',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler',
};
